import { combineReducers } from 'redux'

import list from './list/slice'

const candidatesReducer = combineReducers({
  list,
})

export default candidatesReducer
